export enum AffiliateTypesEnum {
  ADMIN = "ADMIN",
  TECHNICAL = "TECHNICAL",
  MANAGER = "MANAGER",
  ASSISTANT = "ASSISTANT",
}

export interface AffiliateType {
  affiliate_id: string;
  member_id: string;
  created: string;
  description: string;
  email: string;
  name: string;
  social_name: string | null;
  status: string;
  type: string;
  updated: string | null;
}

export interface AffiliatePayloadType {
  member_id?: string;
  description: string;
  email: string;
  name: string;
  type: string | null;
  status: string;
}
